import { useTranslation } from 'react-i18next'

import { FORMIK_SELECT_EMPTY_VALUE } from '../../../../constants/validation'
import { FieldStackedLabel } from '../../../Field'
import { FormFieldsContainer, FormFieldSelectNG } from '../../../Form'
import {
  FormikEntityActionConfigFields,
  FormikField,
  getFormikFormFieldErrorProps,
} from '../../../Formik'
import { useInitiallyOpenSelect } from '../../../Select'
import { UserStaffFunctionalRoleSelect } from '../../UserStaffFunctionalRoleSelect'
import { USER_STAFF_EDIT_FUNCTIONAL_ROLE_FIELD_NAME } from '../UserStaffEditFunctionalRoleFormModal.constants'

function UserStaffEditFunctionalRoleFormModalFields({
  Select = UserStaffFunctionalRoleSelect,
  typeSelectProps,
}) {
  const { t } = useTranslation()

  const selectStatesRef = useInitiallyOpenSelect()

  return (
    <FormFieldsContainer>
      <FormikEntityActionConfigFields typeSelectProps={typeSelectProps}>
        <FormikField
          Component={FormFieldSelectNG}
          Field={FieldStackedLabel}
          Select={Select}
          controlProps={{
            contentProps: {
              placeholderProps: {
                text: t('UserProfile.SelectFunctionalRoleLabelKey'),
              },
            },
          }}
          emptyValue={FORMIK_SELECT_EMPTY_VALUE}
          fieldComponentProps={{
            label: `${t('UserProfile.FunctionalRoleLabelKey')}:`,
          }}
          getErrorProps={getFormikFormFieldErrorProps}
          name={USER_STAFF_EDIT_FUNCTIONAL_ROLE_FIELD_NAME}
          selectStatesRef={selectStatesRef}
        />
      </FormikEntityActionConfigFields>
    </FormFieldsContainer>
  )
}

export default UserStaffEditFunctionalRoleFormModalFields
